// Domready

$(function () {
  appendMoveTitleTextareaHTMLListEvents();
  appendRemoveTitleTextareaHTMLListEvents();

  $('.input__wrapper[data-input-type="title-textarea-html-list"] .input__add-input-link').on('click', function () {
    var id = uuidv4();
    var editorId = 'editor-' + name + '-' + id;
    var wrapper = $(this).parents('.input__wrapper');
    var scaffold = wrapper.find('.input__scaffold > .title-textarea-html-list__container').clone();
    scaffold.attr('data-id', id);
    scaffold.attr('data-editor-id', editorId);
    scaffold.find('.input__textfield').attr('data-form-value', '');
    scaffold.find('.input__container textarea').attr('data-form-value', '');
    scaffold.find('.title-textarea-html-list__button--move').removeAttr('data-move-event-added').attr('force-disable', 1);
    scaffold.find('.title-textarea-html-list__button--remove').removeAttr('data-remove-event-added');
    scaffold.css({display: 'none'}).appendTo(wrapper.find('.title-textarea-html-list__wrapper'));
    scaffold.slideDown(250);
    appendMoveTitleTextareaHTMLListEvents();
    appendRemoveTitleTextareaHTMLListEvents();

    var name = wrapper.attr('data-form-input');
    var minHeight = wrapper.attr('data-min-height');
    var placeholder = wrapper.attr('data-placeholder');

    initHTMLTextareaTinymce(
      editorId,
      '.input__wrapper[data-form-input="' + name + '"] .title-textarea-html-list__container[data-id="' + id + '"] textarea[data-form-value]',
      minHeight,
      placeholder
    );
  });
});

// Append move functions

function appendMoveTitleTextareaHTMLListEvents() {
  $('.title-textarea-html-list__button--move:not([data-move-event-added])').each(function (
    index,
    item
  ) {
    $(item).on('click', function () {

      if ($(item).attr('force-disable')) {
        return false;
      }

      moveContainer(
        '.title-textarea-html-list__container',
        $(this),
        $(this).hasClass('title-textarea-html-list__button--up') ? 'up' : 'down'
      );
    });

    $(item).attr('data-move-event-added', '');
  });
}

// Append remove functions

function appendRemoveTitleTextareaHTMLListEvents() {
  $('.title-textarea-html-list__button--remove:not([data-remove-event-added])').each(function (
    index,
    item
  ) {
    $(item).on('click', function () {
      var wrapper = $(this).parents('.title-textarea-html-list__container');
      var editorId = wrapper.attr('data-editor-id');
      var editor = app[editorId];

      if (wrapper[0].hasAttribute('data-remove')) {
        wrapper[0].removeAttribute('data-remove');
        wrapper.find('.input__textfield').removeAttr('disabled');
      } else {
        wrapper.find('.input__textfield').attr('disabled', 'disabled');
        wrapper.attr('data-remove', '');
      }
    });

    $(item).attr('data-remove-event-added', '');
  });
}
